import * as React from 'react';

export const etFlagContent: JSX.Element = (
    <>
        <g clip-path='url(#clip0_55_3143)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#2E42A5'
            />
            <mask
                id='mask0_55_3143'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_55_3143)'>
                <path
                    d='M0 13.3333H28V20H0V13.3333Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#E31D1C'
                />
                <path
                    d='M0 0H28V6.66667H0V0Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#FECA00'
                />
                <path
                    d='M8.85052 4.32648C8.85052 4.32648 12.1718 2.84931 12.4736 3.01712C12.7755 3.18493 12.8483 3.66324 13.109 3.66324C13.3696 3.66324 13.8942 3.5121 14.1133 3.5121C14.3323 3.5121 14.5489 3.66324 14.5489 3.66324H15.4843V3.15109L19.7261 4.32648C19.7261 4.32648 17.2521 4.64469 17.0656 4.64469C16.8791 4.64469 17.0656 4.90716 17.0656 4.90716C17.0656 4.90716 16.7128 4.64469 16.1756 4.64469C15.6383 4.64469 14.5489 5.19113 14.5489 5.19113L14.9449 6.0299L14.5489 6.27654L14.1133 6.0299C14.1133 6.0299 14.1415 5.34013 13.9539 5.34013C13.7663 5.34013 13.6295 5.78325 13.6295 6.0299C13.6295 6.27654 13.109 6.27654 13.109 6.27654L13.3415 5.8148C13.3415 5.8148 13.5726 5.04929 13.109 5.04929C12.6454 5.04929 10.532 4.64469 10.532 4.64469L9.99162 4.90716L10.1848 4.32648H8.85052Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#7B2900'
                />
                <path
                    d='M13.8097 14.0355C13.8099 14.0505 13.8449 16.5451 13.6397 16.7591C13.4341 16.973 13.1838 16.7591 12.8595 16.7591C12.5355 16.7583 13.5089 14.6273 13.5089 14.6273L13.8097 14.0355ZM11.2843 9.07355C11.1648 9.66671 11.1467 10.7872 11.5235 11.7034C11.898 12.6135 13.3058 13.3312 13.3253 13.3411C13.3253 13.3411 14.0441 13.4999 12.9522 13.6136C11.86 13.7273 10.7958 13.3875 10.2774 12.2405C9.75925 11.0935 10.2774 8.55304 10.2774 8.55304L11.2843 9.07355Z'
                    fill='#E31D1C'
                />
                <path
                    d='M13.6115 14.4315C13.6115 14.4315 13.0385 16.8553 12.6388 16.8553C12.2399 16.8552 12.6386 16.5231 12.6388 16.3134C12.6388 16.1049 12.2437 16.5178 12.2384 16.5233L12.6388 15.1132L13.2043 14.4315H13.6115ZM10.2628 8.3075C10.1627 9.19298 10.1628 11.4831 10.7394 12.4755C11.3136 13.4633 13.8235 13.8809 13.8459 13.8846C13.837 13.8911 13.3387 14.2496 12.4318 14.4178C11.5167 14.5875 9.77232 13.5787 9.33804 11.8661C8.90463 10.1563 9.57891 7.8359 9.58121 7.828L10.2628 8.3075Z'
                    fill='#2E42A5'
                />
                <path
                    d='M13.1218 14.5579C13.1165 14.5707 12.8001 15.3313 12.4109 15.3313C12.0192 15.3311 12.4111 15.1057 12.0232 15.1057C11.6394 15.1057 12.1797 14.5701 12.1921 14.5579H13.1218ZM9.573 7.64282C9.26485 8.49591 9.3603 10.9438 9.573 12.1594C9.78468 13.3688 11.7785 14.1013 11.7986 14.1086C11.7816 14.1209 11.2838 14.474 10.3845 14.6409C9.46954 14.8105 8.89103 13.6335 8.67554 12.1594C8.46019 10.685 8.89136 7.16333 8.89136 7.16333L9.573 7.64282Z'
                    fill='#FECA00'
                />
                <path
                    d='M13.8276 14.0355C13.8274 14.0501 13.7915 16.5451 13.9966 16.7591C14.2023 16.9736 14.4533 16.7591 14.7778 16.7591C15.1012 16.7573 14.1284 14.6273 14.1284 14.6273L13.8276 14.0355ZM16.353 9.07355C16.4725 9.66668 16.4916 10.7871 16.1147 11.7034C15.7421 12.6094 14.3449 13.3249 14.313 13.3411C14.313 13.3411 13.5938 13.4999 14.686 13.6136C15.7782 13.7272 16.8425 13.3874 17.3608 12.2405C17.8777 11.096 17.3632 8.56442 17.3608 8.55304L16.353 9.07355Z'
                    fill='#E31D1C'
                />
                <path
                    d='M14.025 14.4315C14.025 14.4315 14.598 16.8553 14.9977 16.8553C15.3965 16.8551 14.9979 16.5231 14.9977 16.3134C14.9977 16.1044 15.3948 16.5199 15.398 16.5233L14.9977 15.1132L14.4322 14.4315H14.025ZM17.3736 8.3075C17.4738 9.19298 17.4737 11.4831 16.8971 12.4755C16.3234 13.4624 13.8174 13.8802 13.7906 13.8846C13.801 13.8921 14.2992 14.2498 15.2047 14.4178C16.1198 14.5875 17.8642 13.5787 18.2984 11.8661C18.7316 10.1575 18.0584 7.8389 18.0553 7.828L17.3736 8.3075Z'
                    fill='#2E42A5'
                />
                <path
                    d='M14.5155 14.5579C14.5223 14.5742 14.8373 15.331 15.2255 15.3313C15.618 15.3313 15.2259 15.1057 15.6142 15.1057C16.002 15.1055 15.4442 14.5579 15.4442 14.5579H14.5155ZM18.0634 7.64282C18.3715 8.49591 18.2761 10.9438 18.0634 12.1594C17.8517 13.3686 15.8584 14.1011 15.8378 14.1086C15.8549 14.1209 16.3527 14.474 17.2519 14.6409C18.1668 14.8105 18.7454 13.6335 18.9608 12.1594C19.1762 10.6849 18.745 7.16333 18.745 7.16333L18.0634 7.64282Z'
                    fill='#FECA00'
                />
                <path
                    d='M9.23868 8.04911L9.31185 7.61454L10.5911 7.69608L9.62077 6.70644L9.94772 6.40026L11.2601 7.73872L10.1381 5.66176L10.526 5.43464L11.5475 6.91399L11.0602 5.37633L11.4792 5.21228L13.0499 8.29627L12.4474 8.25787L12.5064 8.44416L13.0194 8.57809L12.9025 9.00563L12.6647 8.94353L12.8869 9.64474L12.5009 9.08576L13.1729 10.3292L11.5217 8.64514L9.23868 8.04911Z'
                    fill='#6FAE21'
                />
                <path
                    d='M18.6064 8.04911L18.5332 7.61454L17.2539 7.69608L18.2243 6.70644L17.8973 6.40026L16.5849 7.73872L17.7069 5.66176L17.3191 5.43464L16.2975 6.91399L16.7848 5.37633L16.3658 5.21228L14.7951 8.29627L15.3977 8.25787L15.3386 8.44416L14.8256 8.57809L14.9425 9.00563L15.1804 8.94353L14.9582 9.64474L15.3442 9.08576L14.6721 10.3292L16.3233 8.64514L18.6064 8.04911Z'
                    fill='#6FAE21'
                />
                <path
                    d='M9.92927 16.5971L9.59979 16.2936L19.3411 6.19611L19.6705 6.49968L9.92927 16.5971Z'
                    fill='#171401'
                />
                <path
                    d='M19.0942 6.27383L19.5936 6.73755L19.8751 5.97095L19.0942 6.27383Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#CECECC'
                />
                <path
                    d='M10.1768 16.595L9.60314 16.2237L9.4173 16.9848L10.1768 16.595Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#CECECC'
                />
                <path
                    d='M9.20493 15.0925L8.87546 14.7889L18.6167 4.69147L18.9462 4.99504L9.20493 15.0925Z'
                    fill='#171401'
                />
                <path
                    d='M18.3691 4.76919L18.8685 5.23291L19.15 4.46631L18.3691 4.76919Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#CECECC'
                />
                <path
                    d='M9.45247 15.0904L8.87881 14.7191L8.69296 15.4802L9.45247 15.0904Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#CECECC'
                />
                <path
                    d='M18.0697 16.5971L18.3991 16.2936L8.65786 6.19611L8.32839 6.49968L18.0697 16.5971Z'
                    fill='#171401'
                />
                <path
                    d='M8.90543 6.27383L8.40597 6.73755L8.12446 5.97095L8.90543 6.27383Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#CECECC'
                />
                <path
                    d='M17.822 16.595L18.3957 16.2237L18.5815 16.9848L17.822 16.595Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#CECECC'
                />
                <path
                    d='M18.9749 15.4466L19.3044 15.143L9.56314 5.04553L9.23366 5.34911L18.9749 15.4466Z'
                    fill='#171401'
                />
                <path
                    d='M9.8107 5.12325L9.31124 5.58698L9.02974 4.82037L9.8107 5.12325Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#CECECC'
                />
                <path
                    d='M18.7273 15.4444L19.301 15.0731L19.4868 15.8343L18.7273 15.4444Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='#CECECC'
                />
                <rect
                    x='12.0072'
                    y='12.7136'
                    width='3.62257'
                    height='1.77013'
                    fill='#B74E01'
                />
                <use
                    xlinkHref='#stroke0_55_3143'
                    fill='#7DB8FF'
                />
                <mask
                    id='stroke1_55_3143'
                    maskUnits='userSpaceOnUse'
                    x='10.5656'
                    y='5.15369'
                    width='6'
                    height='9'
                    fill='black'
                >
                    <rect
                        fill='white'
                        x='10.5656'
                        y='5.15369'
                        width='6'
                        height='9'
                    />
                    <use xlinkHref='#stroke0_55_3143' />
                </mask>
                <path
                    d='M13.8297 13.2342C15.0802 13.2342 16.0939 11.6492 16.0939 9.69396C16.0939 7.73872 15.0802 6.15369 13.8297 6.15369C12.5793 6.15369 11.5656 7.73872 11.5656 9.69396C11.5656 11.6492 12.5793 13.2342 13.8297 13.2342Z'
                    stroke-width='0.786727'
                    stroke='#FECA00'
                    mask='url(#stroke1_55_3143)'
                />
                <mask
                    id='mask1_55_3143'
                    style={{ maskType: 'luminance' }}
                    maskUnits='userSpaceOnUse'
                    x='11'
                    y='5'
                    width='6'
                    height='9'
                >
                    <use
                        xlinkHref='#stroke2_55_3143'
                        fill='white'
                    />
                    <mask
                        id='stroke3_55_3143'
                        maskUnits='userSpaceOnUse'
                        x='10.5656'
                        y='5.15369'
                        width='6'
                        height='9'
                        fill='black'
                    >
                        <rect
                            fill='white'
                            x='10.5656'
                            y='5.15369'
                            width='6'
                            height='9'
                        />
                        <use xlinkHref='#stroke2_55_3143' />
                    </mask>
                    <path
                        d='M13.8297 13.2342C15.0802 13.2342 16.0939 11.6492 16.0939 9.69396C16.0939 7.73872 15.0802 6.15369 13.8297 6.15369C12.5793 6.15369 11.5656 7.73872 11.5656 9.69396C11.5656 11.6492 12.5793 13.2342 13.8297 13.2342Z'
                        stroke-width='0.786727'
                        stroke='white'
                        mask='url(#stroke3_55_3143)'
                    />
                </mask>
                <g mask='url(#mask1_55_3143)'>
                    <path
                        d='M11.3782 9.75144H12.6665C12.6665 9.75144 13.5522 9.94464 13.1094 10.0966C12.6665 10.2486 12.6665 10.2989 12.6665 10.5157C12.6665 10.7324 12.6665 11.5257 12.6665 11.6951C12.6665 11.8645 12.9816 12.2272 12.3176 12.2272C11.6536 12.2272 11.0815 9.53973 11.0815 9.53973L11.3782 9.75144Z'
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        fill='#6FAE21'
                    />
                    <path
                        d='M16.4121 9.89746C16.4121 9.89746 15.2153 10.1302 14.3954 10.0526C13.5755 9.97505 13.2157 9.89746 13.2157 9.89746C13.2157 9.89746 13.7872 10.1901 13.9902 10.4353C14.1933 10.6806 14.6092 11.1046 15.0331 11.1046C15.4569 11.1046 16.1067 11.5004 16.1067 11.5004L16.4121 9.89746Z'
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        fill='#6FAE21'
                    />
                    <path
                        d='M11.7291 7.80487C11.7291 7.80487 12.7157 7.99259 12.9533 8.27367C13.191 8.55476 12.6394 8.83584 14.077 8.55476C15.5146 8.27367 16.6557 7.78337 16.6557 8.55476C16.6557 9.32614 16.5301 10.0367 15.9115 10.0367C15.2929 10.0367 15.0461 10.0367 13.1595 10.0367C11.2729 10.0367 10.2444 10.6048 10.3765 9.69073C10.5086 8.77662 11.7291 7.80487 11.7291 7.80487Z'
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        fill='#F7FCFF'
                    />
                </g>
            </g>
        </g>
        <defs>
            <clipPath id='clip0_55_3143'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
            <path
                id='stroke0_55_3143'
                d='M13.8297 13.2342C15.0802 13.2342 16.0939 11.6492 16.0939 9.69396C16.0939 7.73872 15.0802 6.15369 13.8297 6.15369C12.5793 6.15369 11.5656 7.73872 11.5656 9.69396C11.5656 11.6492 12.5793 13.2342 13.8297 13.2342Z'
                fill-rule='evenodd'
                clip-rule='evenodd'
            />
            <path
                id='stroke2_55_3143'
                d='M13.8297 13.2342C15.0802 13.2342 16.0939 11.6492 16.0939 9.69396C16.0939 7.73872 15.0802 6.15369 13.8297 6.15369C12.5793 6.15369 11.5656 7.73872 11.5656 9.69396C11.5656 11.6492 12.5793 13.2342 13.8297 13.2342Z'
                fill-rule='evenodd'
                clip-rule='evenodd'
            />
        </defs>
    </>
);
